export default {
  // 標題和描述
  title: "用戶分享的畫布",
  sharedCanvas: "分享的畫布",
  userUid: "用戶uid",
  welcomeText: "歡迎使用",

  // 系統描述
  systemDescription: "以鏈上交易溯源及匿名身份穿透為核心，打擊涉虛擬貨幣新型犯罪的一站式查控平台。",

  // 功能列表
  feature1: "行業領先的地址標籤庫",
  feature2: "賦能行業超前的安全響應能力",
  feature3: "多維度助推案件質效提升",
  feature4: "調證目標一鍵直達",

  // 輸入框
  enterAccessPassword: "請輸入訪問密碼",

  // 時間相關
  expirationTime: "到期時間",

  // 按鈕
  confirm: "確認",

  // 錯誤信息
  canvasExpired: "該畫布分享已過期或者已關閉分享，暫時無法訪問",
};
